var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.languages,"label":"Language","variant":"outlined","dense":"","hide-details":""},on:{"change":_vm.changeLanguage},model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }